import { translate } from '../../helpers/translate.helper';
import { useRole } from '../../hooks/useRole';
import { Box } from '../../ui/Box';

import { CustomerCompanyMultiSelect, type CustomerCompanyMultiSelectProps } from './CustomerCompanyMultiSelect';

// To be used at overview pages within a flex container

interface OverviewCustomerCompanySelectProps extends Pick<CustomerCompanyMultiSelectProps, 'onChange' | 'value'> {}

export const OverviewCustomerCompanySelect = (props: OverviewCustomerCompanySelectProps) => {
    const role = useRole();
    return (
        <Box minWidth="250px">
            <CustomerCompanyMultiSelect
                {...props}
                dropdownWidth="520px"
                placeholder={
                    role.isSuperAdmin()
                        ? translate('placeholder.filter.customer')
                        : translate('placeholder.filter.company')
                }
                clearSearchOnSelect={false}
            />
        </Box>
    );
};
